import {
  Div,
  Flex,
  LoadingSpinner,
  Text,
} from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { CertifiedCoachBadge } from 'src/coaching/svg/certifiedCoachBadge'
import { CoachingBadgeType } from 'src/coaching/svg/coachingBadgeSVGs'
import { Clipboard } from './components/Clipboard'
import { useSelector } from 'src/hooks'
import { Button as DSButton } from 'src/design_system/components/Button/Button'
import { useByDesignLoginLink } from 'src/react_query'

interface Props {
  title: string
  date: string
  location: string
  badge: CoachingBadgeType
  code?: {
    title: string
    value: string
  }
  action?: {
    onClick?: () => void
    onBydesignRedirect?: string
    title: string
  }
}

const CoachingEventCard: React.FC<Props> = props => {
  const { title, date, location, code, action, badge } = props

  const { isLoading: isCreatingBydesignLoginLink, data: byDesignLoginLink } =
    useByDesignLoginLink()

  const onActionClick = () => {
    if (action?.onClick) {
      action.onClick()
    }
    if (action?.onBydesignRedirect) {
      window.open(`${byDesignLoginLink}/${action?.onBydesignRedirect}`)
    }
  }

  const isMobile = useSelector(state => state.window.isMobile)

  return (
    <>
      {isCreatingBydesignLoginLink ? (
        <LoadingSpinner size="medium" />
      ) : (
        <Div
          display="flex"
          flexDirection="column"
          flexGrow={1}
          backgroundColor="foreground"
          borderRadius="default"
          inset={{ vertical: 'x1', horizontal: 'x2' }}
          rowGap="x1_5"
        >
          <Flex
            flexDirection="column"
            width="100%"
            rowGap="x1_5"
            alignItems={isMobile ? 'flex-start' : 'stretch'}
            flexGrow={1}
          >
            <Flex
              flexDirection="row"
              alignItems="start"
              justifyContent="space-between"
              columnGap="x1"
            >
              <Text
                type="body"
                color="primaryHeading"
                content={title}
                whiteSpace="normal"
                weight="extraBold"
              />
              <CertifiedCoachBadge badge={badge} size={50} />
            </Flex>
            <Flex
              width="100%"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
              columnGap="x2"
              rowGap="x_5"
              flexWrap={isMobile ? 'wrap' : 'nowrap'}
            >
              <Text
                type="footnote"
                color="primaryBody"
                content={date}
                weight="bold"
                style={{ color: '#6b7280', fontWeight: 600 }}
              />
              <Text
                type="footnote"
                color="primaryBody"
                content={location}
                weight="bold"
                style={{ color: '#000000', fontWeight: 600 }}
              />
            </Flex>
            {code ? (
              <Flex flexDirection="row" alignItems="center" columnGap="x1">
                <Text
                  type="caption"
                  content="Ticket Code:"
                  weight="bold"
                  style={{ color: '#000000', fontSize: '12px', lineHeight: 1 }}
                />
                <Clipboard copyText={code.value} isCompact />
              </Flex>
            ) : null}
            {action ? (
              <Flex
                outset={{ top: 'x_5' }}
                width="100%"
                alignItems="center"
                columnGap="x1"
                style={{ marginTop: 'auto' }}
              >
                <DSButton
                  title={action.title}
                  onClick={onActionClick}
                  width="100%"
                  backgroundColor="#424548"
                  textSize="12px"
                  padding="12px 16px"
                />
              </Flex>
            ) : null}
          </Flex>
        </Div>
      )}
    </>
  )
}

export default CoachingEventCard
